import { render } from "./CountDropdownHotel.vue?vue&type=template&id=672053aa"
import script from "./CountDropdownHotel.vue?vue&type=script&lang=js"
export * from "./CountDropdownHotel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__